import './styles.scss';

interface GradientBlurProps {
  direction: 'top' | 'bottom';
};

const GradientBlur = ({ direction = 'top' }: GradientBlurProps) => {
  return (
    <div className={`gradient-blur-container gb-direction-${direction}`}>
      <span className="gradient-blur"></span>
      <span className="gradient-blur"></span>
      <span className="gradient-blur"></span>
      <span className="gradient-blur"></span>
      <span className="gradient-blur"></span>
    </div>
  );
};
GradientBlur.displayName = 'GradientBlur';

export { GradientBlur };